import { nsSelector } from "../utils/redux";

const mainSelector = nsSelector("main");
export const token = mainSelector("token");
export const isLogin = mainSelector("isLogin");
